"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const colors_1 = require("../../../styles/colors");
const material_1 = require("@mui/material");
const LabelBox_1 = require("../../atoms/LabelBox/LabelBox");
const backgroundActiveNode = 'transparent linear-gradient(76deg, #00CDFB 0%, #009EDC 100%) 0% 0% no-repeat padding-box;';
function StatusBox({ data, activeNodeIndex, }) {
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, Object.assign({ direction: "row", spacing: 2 }, { children: data.map((label, index) => index === activeNodeIndex ? ((0, jsx_runtime_1.jsx)(LabelBox_1.LabelBox, { label: label, background: backgroundActiveNode, color: colors_1.$primaryWhite }, label)) : ((0, jsx_runtime_1.jsx)(LabelBox_1.LabelBox, { label: label, background: colors_1.$grey5, color: colors_1.$grey30 }, label))) })));
}
exports.StatusBox = StatusBox;
